import register from 'preact-custom-element'

import ProductPriceBlockController from './productPriceBlockController/ProductPriceBlockController'

register(
  ProductPriceBlockController,
  'product-price-block-controller',
  [
    'articles',
    'article-erp-item-number',
    'channel-id',
    'config-result',
    'await-config-result-before-pricehelper-request',
    'category',
    'sub-category',
    'weeks-until-delivery',
    'addons',
    'struct-sku',
  ],
  { shadow: false }
)
